import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component, OnDestroy} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {EntitlementEntityModel} from "../entitlement-entity.model";
import {EntitlementProductData} from "../entitlement.data";
import {
    ProductLineSearchPageComponent
} from "../../../catalogue/product-line/product-line-search-page/product-line-search-page.component";
import {
    ProductLineEditPageComponent
} from "../../../catalogue/product-line/product-line-edit-page/product-line-edit-page.component";
import {
    CompositeProductSearchPageComponent
} from "../../../catalogue/composite-product/composite-product-search-page/composite-product-search-page.component";
import {
    CompositeProductEditPageComponent
} from "../../../catalogue/composite-product/composite-product-edit-page/composite-product-edit-page.component";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {PricingScheduleSummaryData} from "../../pricing-schedule/pricing-schedule.data";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {Subscription} from "rxjs";

@Component({
    selector: "wbo-entitlement-edit-page",
    styleUrls: ["./entitlement-edit-page.component.scss"],
    templateUrl: "./entitlement-edit-page.component.html",
    providers: [provideEntityModel(EntitlementEntityModel)]
})
export class EntitlementEditPageComponent extends AbstractEditPage implements OnDestroy {
    ProductLineSearchPageComponent = ProductLineSearchPageComponent;
    ProductLineEditPageComponent = ProductLineEditPageComponent;
    CompositeProductSearchPageComponent = CompositeProductSearchPageComponent;
    CompositeProductEditPageComponent = CompositeProductEditPageComponent;
    PricingScheduleSummaryData = PricingScheduleSummaryData;
    EditMode = EditMode;

    private subscriptions: Subscription = new Subscription();

    constructor(public model: EntitlementEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    saving() {
        this.model.data.status = this.model.data.derivedStatus;
        if (this.model.data.usageCount === null) {
            this.model.data.usageCount = 0;
        }
    }

    afterEntityAdded(product: EntitlementProductData): void {
        product.quantity = 1;
    }

    get title(): string {
        return this.model.data.distributionChannel.distributionReference && this.model.data.externalId ? this.model.data.distributionChannel.distributionReference + " - " + this.model.data.externalId
            : this.model.data.distributionChannel.distributionReference ? this.model.data.distributionChannel.distributionReference
                : this.model.data.externalId ? this.model.data.externalId
                    : undefined;
    }

    get dealTitlePlaceholder(): string {
        return "'" + (this.model.data.distributionChannel.distributionReference || " ") + "'";
    }
}
